<form [formGroup]="userGridForm">
  <!--Title-->
  <div class="d-flex justify-content-between align-items-center">
    <h3>{{'_General_Users_Text_' | translate }}</h3>
    <!-- Add User Button-->
    <button *ngIf="userPermissionList?.includes(19)" type="button" class="btn btn-primary"
      (click)="goToUserSettings()">{{'_General_Add_User_Text_' | translate }}</button>
  </div>
  <div class="cc-content-wrapper">
    <!--Action Panel-->
    <div class="cc-action-panel row">
      <!--Filters-->
      <div class="central-view-filters">
        <div class="me-3">
          <label>{{'_User_Active_Status_Label_Text_' | translate }}</label>
          <select (change)="onStatusChanged()" class="cc-select-dropdown form-control" [(ngModel)]="userStatus"
            formControlName="activeStatus">
            <option [ngValue]="status.id" *ngFor="let status of activeStatusList">{{status.displayValue | translate}}</option>
          </select>
        </div>
        <div class="me-3">
          <label>{{'_General_Permission_Group_Text_' | translate}}</label>
          <select (change)="onPermissionGroupChanged()" class="cc-select-dropdown form-control permission-selector-view"
            [(ngModel)]="selectedPermissionGroup" formControlName="permissionGroup">
            <option [ngValue]="-1">{{'_General_All_Text_' | translate }}</option>
            <option *ngFor="let permissionGroup of permissionGroupList" [ngValue]="permissionGroup.id">
              {{permissionGroup.name | translate}}
            </option>
          </select>
        </div> 
        <div class="d-flex flex-column me-3">
          <label>{{'_General_Location_Text_' | translate }}</label>
          <app-location-selector class="location-selector-view" [isDisableParentClick]="true"
            [selectorDisabled]="isLocationSelctorDisabled" (onChange)="onLocationChange($event)"
            [selectedLocationId]="locationId" [selectedLocationName]="locationName"
            (onLocationsData)="onLocationDataRecived($event)" [isIncludeFloatLocation]="false">
          </app-location-selector>
        </div>
        <div>
          <label>
            <input class="cc-filter-checkbox" type="checkbox" kendoCheckBox formControlName="includeSubLocations"
              (change)="onIncludeSubLocationsChange()" />
            {{'_General_Include_Sub_Locations_Text_' | translate }}
          </label>
        </div>
      </div>

      <!--Search-->
      <div class="cc-search with-close">
        <input id="userSearchText" type="text" class="form-control" placeholder="{{'_General_Search_Text_' | translate }}" (keydown.enter)="searchKeyWordChange()"
          formControlName="searchUser" />
        <button id="userSearchButton" type="button" class="cc-search-btn" (click)="searchKeyWordChange()"><span
            class="fas fa-search"></span></button>
        <button type="button" [ngClass]="{'show-btn': showClearButton}" (click)="onClearSearchTextClicked()"
          class="cc-close-btn"><span class="fas fa-times"></span></button>
      </div>
    </div>

    <!--User Grid-->
    <div class="common-grid-wrapper">
      <kendo-grid [data]="data" [pageSize]="pageInfo.PageSize" [skip]="(pageInfo.Page - 1) * pageInfo.PageSize"
        [pageable]="true" (cellClick)="onToggle($event)" [sortable]="{allowUnsort: false, mode: 'single'}"
        (sortChange)="sortChange($event)" scrollable="scrollable" (pageChange)="onPageChange($event)"
        (edit)="editHandler($event)" (remove)="deactivateUser($event)" [sort]="sort">
        <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>
        <kendo-grid-column field="userCode" title="{{'_General_User_Code_Text_' | translate }}" [width]="100" [headerStyle]="{'font-weight' : 'bold'}">
        </kendo-grid-column>
        <kendo-grid-column field="userName" title="{{'_General_Username_Text_' | translate }}" [width]="200" [headerStyle]="{'font-weight' : 'bold'}">
        </kendo-grid-column>
        <kendo-grid-column field="firstName" title="{{'_General_User_First_Name_Text_' | translate }}" [width]="130" [headerStyle]="{'font-weight' : 'bold'}">
        </kendo-grid-column>
        <kendo-grid-column field="lastName" title="{{'_General_User_Last_Name_Text_' | translate }}" [width]="150" [headerStyle]="{'font-weight' : 'bold'}">
        </kendo-grid-column>
        <kendo-grid-column field="homeLocation" title="{{'_General_Home_Location_Text_' | translate }}" [width]="150"
          [headerStyle]="{'font-weight' : 'bold'}">
        </kendo-grid-column>
        <kendo-grid-column field="permissionGroup" title="{{'_General_Permission_Group_Text_' | translate }}" [width]="150"
          [headerStyle]="{'font-weight' : 'bold'}">
        </kendo-grid-column>
        <!-- <kendo-grid-column field="notificationGroupList" title="Notification Group(s)"
          [headerStyle]="{'font-weight' : 'bold'}">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
            <span>
              <button type="button" *ngIf="dataItem.notificationGroupList.length>1"
                (click)="openGroupNotificationPopUp(dataItem.notificationGroupList)" class="cc-icon-btn"
                title="Edit"><span class="fas fa-plus"></span></button>
              {{dataItem.notificationGroupList[0]}}
            </span>
          </ng-template>
        </kendo-grid-column> -->
        <kendo-grid-command-column title="{{'_General_Button_Action_Text_' | translate }}" [width]="100" [headerStyle]="{'font-weight' : 'bold', 'text-align':'center', 'justify-content': 'center'}">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="cell-items-center">
              <button *ngIf="userPermissionList?.includes(20)" type="button" class="cc-icon-btn edit" title="{{'_General_Button_Edit_Text_' | translate }}"
                kendoGridEditCommand><span class="fas fa-pen"></span></button>
              <span title="{{!userPermissionList.includes(21)?activeDeactivateDisabledMsg:'_Product_Services_Grid_Deactivate_Title_Text_' | translate }}">
                <button type="button" class="cc-icon-btn"
                  (click)="deactivateUser(dataItem)" *ngIf="dataItem.isActive"
                  [class.disableNode]="!userPermissionList.includes(21)"><span class="fas fa-lock"></span></button>
              </span>
              <span title="{{!userPermissionList.includes(21)?activeDeactivateDisabledMsg:'_Product_Services_Grid_Activate_Title_Text_' | translate }}">
                <button type="button" class="cc-icon-btn"
                (click)="activateUser(dataItem)" *ngIf="!dataItem.isActive"
                [class.disableNode]="!userPermissionList.includes(21)"><span class="fas fa-lock-open"></span></button>
              </span>
            </div>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid>
    </div>
  </div>

  <app-modalpopup header="{{'_User_Deactivate_User_Popup_Header_Text_' | translate }}" [(dialogOpened)]="showDeactivate" [isInfo]="false" actionNoLabel="{{'_General_Action_Label_No_Text_' | translate }}"
    actionYesLabel="{{'_General_Action_Label_Yes_Text_'| translate }}" message="{{'_User_Deactivate_User_Popup_Message_Text_' | translate }}" (submitted)="onDeactiveUser()"
    (cancelled)="onNoClick()">
  </app-modalpopup>

  <app-modalpopup header="{{'_User_Activate_User_Popup_Header_Text_' | translate }}" [(dialogOpened)]="showActivate" [isInfo]="false" actionNoLabel="{{'_General_Action_Label_No_Text_' | translate }}"
    actionYesLabel="{{'_General_Action_Label_Yes_Text_' | translate }}" message="{{'_User_Activate_User_Popup_Message_Text_' | translate }}" (submitted)="onActiveUser()"
    (cancelled)="onNoClick()">
  </app-modalpopup>
</form>
